module.exports = __webpack_public_path__ + "img/image5.bfc786e6.webp";